import React, { FC, useCallback, useMemo } from 'react'
import { DatePicker } from 'antd'
import dayjs from 'dayjs'
import { Constants } from '../../../../constants'

const { RangePicker } = DatePicker

export const NextTableDateFilter: FC<any> = ({ column: { filterValue, setFilter }, dateFormat = Constants.DATE_TIME, ...restProps }) => {
  const value = useMemo(() => {
    if (filterValue) {
      return filterValue.split(',').map((date) => dayjs(date, dateFormat))
    }
  }, [filterValue, dateFormat])

  const handleChange = useCallback(
    (value) => {
      if (value instanceof Array) {
        setFilter(value.map((date) => dayjs(date, dateFormat).format(dateFormat)).join(','))
      } else {
        setFilter(undefined)
      }
    },
    [setFilter, dateFormat],
  )

  return <RangePicker {...restProps} showTime={dateFormat !== Constants.DATE} onChange={handleChange} value={value} format={dateFormat} />
}
